//import { Pagination } from "../components/common/page-components";
import { gallery } from "../data/dummyData";

const Gallery = () => {
  return (
    <div className="pt-20 px-[3%] md:px-[6%]">
    <div className="text-center">
      <h1 className="mx-auto sub-heading">Gallery</h1>
      <h1 className="heading">explore more of our properties</h1>
    </div>
    <div className="grid grid-cols-1 gap-3 mt-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
         {gallery.map(({ id, image }) => (
          <div className="h-[250px] w-full mb-16" key={id}>
            <img src={image} alt={image.alt} className="object-cover w-full h-full rounded-lg" />
          </div>
   
        ))}
    </div>
    </div>

  );
};


export default Gallery;
